export const E2E_ENABLED = process.env.EXPO_PUBLIC_E2E === 'true'

export function isE2EEnabled(): boolean {
  return E2E_ENABLED
}

export function isE2EMockApiEnabled(): boolean {
  return E2E_ENABLED && process.env.EXPO_PUBLIC_E2E_MOCK_API === 'true'
}

export function isE2EMockAuthEnabled(): boolean {
  return E2E_ENABLED && process.env.EXPO_PUBLIC_E2E_MOCK_AUTH === 'true'
}

export const E2E_CLAIM_FAIL_ONCE_KEY = 'turbina_e2e_claim_fail_once'
export const E2E_STATS_FAIL_ONCE_KEY = 'turbina_e2e_stats_fail_once'
export const E2E_WAITLIST_FAIL_ONCE_KEY = 'turbina_e2e_waitlist_fail_once'
export const E2E_CREATE_USER_FAIL_ONCE_KEY = 'turbina_e2e_create_user_fail_once'
export const E2E_PATCH_ONBOARDING_FAIL_ONCE_KEY = 'turbina_e2e_patch_onboarding_fail_once'
export const E2E_SIGNIN_FAIL_ONCE_KEY = 'turbina_e2e_signin_fail_once'

function canUseWindowStorage(): boolean {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'
}

export function readE2EBooleanFlag(key: string): boolean {
  if (!canUseWindowStorage()) return false
  return window.localStorage.getItem(key) === 'true'
}

export function writeE2EBooleanFlag(key: string, value: boolean): void {
  if (!canUseWindowStorage()) return
  window.localStorage.setItem(key, value ? 'true' : 'false')
}
